import { motion } from "framer-motion";
import { STATS } from "@/data/content";

export const Stats = () => {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-forest text-cream overflow-hidden py-24 md:py-36"
    >
      <div className="noise-overlay absolute inset-0 opacity-[0.12] pointer-events-none" />
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-green/20 blur-3xl" />
      <div className="absolute -bottom-32 -left-20 h-96 w-96 rounded-full bg-mango/10 blur-3xl" />

      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
        <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95] max-w-3xl mb-16 md:mb-24">
          Estás a tiempo de{" "}
          <span className="text-mango">surfear la ola</span> digital.
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`stat-${i}`}
              className="border-t border-cream/15 pt-6"
            >
              <p className="font-display font-black text-5xl md:text-7xl tracking-tighter text-mango">
                {s.value}
              </p>
              <p className="mt-3 text-cream/60 text-sm md:text-base">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
